import { Platform, StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
    },
    rightMarker: {
        right: Platform.select({ web: widthPercentageToDP(72), default: 2 }),
    },
    leftMarker: {
        left: Platform.select({ web: widthPercentageToDP(72), default: 2 }),
    },
});

export default styles;
